import React from 'react'
import Data from '../components/recovery/Data'
import Footer from '../components/footer/Footer'
import Navbar from '../components/navbar/Navbar'

const Recovery = () => {
  return (
    <div>
        <Navbar/>
        <Data/>
        <Footer/>
    </div>
  )
}

export default Recovery